import React from 'react';
import { Clock } from 'lucide-react';
export function PainSection() {
  return <section className="py-12 md:py-16 bg-warm-200" data-id="element-192">
      <div className="max-w-3xl mx-auto px-4" data-id="element-193">
        <div className="flex items-center gap-3 mb-6" data-id="element-194">
          <div className="bg-primary-100 p-2 rounded-full" data-id="element-195">
            <Clock className="w-5 h-5 text-primary-600" data-id="element-196" />
          </div>
          <span className="text-2xl md:text-3xl font-bold text-text-dark" data-id="element-197">
            Son las 3:17 AM.
          </span>
        </div>

        <div className="space-y-4 text-text-body leading-relaxed" data-id="element-198">
          <p data-id="element-199">
            Estás en el pasillo con el bebé en el hombro. Los ojos ya no
            distinguen si están abiertos o cerrados. Y aparece ese pensamiento
            que no le contás a nadie:
          </p>

          <div className="bg-white p-5 rounded-xl shadow-sm text-center my-6" data-id="element-200">
            <p className="text-xl font-semibold text-text-dark" data-id="element-201">
              "¿Cuánto más voy a aguantar esto?"
            </p>
          </div>

          <p data-id="element-202">
            Afuera pasa un bus. El bebé que acababa de calmarse vuelve a llorar.{' '}
            <strong className="text-text-dark" data-id="element-203">Empezás de cero.</strong>
          </p>

          <p data-id="element-204">
            Al día siguiente llegás al trabajo con ojeras. Cometés errores.
            Respondés seco. El cansancio ya está cobrando cosas que no querés
            perder: tu concentración, tu paciencia, tu pareja.
          </p>

          <p className="text-primary-600 font-medium pt-2" data-id="element-205">
            Esto no es culpa tuya. Es que nadie te dijo por qué los métodos que
            leíste no funcionan aquí.
          </p>
        </div>
      </div>
    </section>;
}